/** @namespace TS */
/** @namespace TS.viewModel */

/**
 *  A Knockout [observable]{@link http://knockoutjs.com/documentation/observables.html} object.
 * @typedef Observable
 * */

TS.ns('TS.domain');

(function () {
    'use strict';

    /**
     * @class TS.domain.Domain
     * @ignore
     * @classdesc This is the base class for all view models. This class should not be directly instatiated.
     */
    TS.domain.Domain = new Class(
        /** @lends TS.domain.Domain# */
        {
            Extends: TS.Observable,

            events: [
                /**
                 * Fires when the view model is closed.
                 * @event TS.domain.Domain#close
                 */
                'close'
            ],

            postTarget: null,
            executingCommandCode: "",

            /**
             * Title of the view model. Usually displayed in the page header, it's also used for the browser window title.
             * @member {String}
             */
            Title: null,

            /**
             * Command categories
             * @member {Object}
             */
            CommandCategories: {},

            /**
             * View model's properties.
             * <p><span class="label label-warning">Warning</span>
             * Modifying the contents this collection can lead to undesired side-effects.
             * </p>
             * @member {Array.<TS.viewModel.DomainProperty>}
             */
            DomainProperties: [],

            Bindings: {},

            _cmdHandlers: {
                'Record.Close': 'close'
            },

            observables: {
                ReadOnly: false
            },

            mapping: {
                ignore: ['CommandCategories', 'DomainProperties', 'Bindings', 'propertyType'],
                copy: ['messages', 'subdomainPath', 'modelUID', '__objecttype__'],
                suppress: ['Title', 'messages', 'modelUID', '__objecttype__', 'rootUrl', 'subdomainPath'],
                domains: []
            },

            //region Constructor

            initialize: function (config) {
                var me = this,
                    hasSubdomains = me.mapping.domains && me.mapping.domains.length;

                me.parent();

                if (hasSubdomains) {
                    me.mapping.ignore = (me.mapping.ignore || []).concat(me.mapping.domains);
                }

                //copy properties from config
                this.config = TS.makeDates(config);
                Object.append(me, ko.mapping.fromJS(this.config, this.getMappingOptions()));

                me._setWindowTitle();

                me.initializeProperties(config);

                //after all is set, create bindings
                config.Bindings && me.createBindings(config.Bindings);
            },

            initializeProperties: function (config) {
                var me = this,
                    hasSubdomains = me.mapping.domains && me.mapping.domains.length;

                config.CommandCategories && me.createCommands(config.CommandCategories);
                config.DomainProperties && me.createProperties(config.DomainProperties);
                hasSubdomains && me.createSubdomains(config);
            },

            getMappingOptions: function () {
                return this.mapping;
            },

            //endregion

            //region Commands

            /**
             * Creates a new command category and adds it to the domain.
             * @param code The code of the command category.
             * @param config The configuration object containing category meta.
             */
            createCommandCategory: function (code, config) {
                var me = this;
                if (config) {
                    config.Code = config.Code || code;
                    me.CommandCategories[code] = new TS.domain.CommandCategory(config, me);
                    me.CommandCategories[code]._autocreated = true;
                }
            },

            createCommands: function (config) {
                $.each(config, this.createCommandCategory.bind(this));
                this._assignCommandHandlers();
            },

            updateCommands: function (config) {
                var me = this;
                $.each(config, function (name, value) {
                    var category = me.CommandCategories[name];
                    if (!category) {
                        me.createCommandCategory(name, value);
                    } else {
                        category._setData(value);
                    }
                });

                $.each(me.CommandCategories, function (name, value) {
                    var category = config[name];
                    if (!category && value._autocreated === true) {
                        delete me.CommandCategories[name];
                    }
                });
            },

            _assignCommandHandlers: function () {
                var me = this;

                // assign default command handlers
                if (me._cmdHandlers !== null) {
                    $.each(me._cmdHandlers, function (cmdCode, handler) {
                        var cmd = me.getCommand(cmdCode);
                        if (cmd && !cmd.hasHandler())
                            cmd.handler = TS.unwrap(handler);
                    });
                }
            },

            /**
             * Retrieves a command by its code
             * @param cmdCode {String}
             * @returns {TS.viewModel.Command}
             *
             * @example
             *
             * ...
             * var me = this,
             *     cmd = me.getCommand('Record.Save');
             *
             * cmd.Enabled(false);
             */
            getCommand: function (cmdCode) {
                var me = this,
                    cats = me.CommandCategories,
                    cat,
                    parentProp,
                    cmd = null,
                    domainProp = null,
                    parts;

                //pattern ParentProperty.CommandCode
                if (cmdCode.indexOf('.') > -1) {
                    parts = cmdCode.split('.');
                    parentProp = parts[0];
                    cmdCode = parts.slice(1).join('.');
                }

                //find by category or domain property
                if (parentProp) {
                    cat = me.CommandCategories[parentProp];
                    if (cat) {
                        cmd = cat.getCommand(cmdCode);
                        if (cmd)
                            return cmd;
                    } else {

                        //get property full path
                        var propCmdName = parts.pop(),
                            propertyName = parts.join('.');

                        //path to command is a domain property
                        domainProp = TS.Util.getProperty(me, propertyName);
                        if (domainProp && domainProp.hasCommands()) {
                            cmd = domainProp.getCommand(propCmdName);
                        }
                    }
                } else {
                    //category not specified, search in all categories
                    $.each(cats, function (catName, c) {
                        cmd = c.getCommand(cmdCode);
                        if (cmd)
                            return false; //break
                    });
                }

                return cmd;
            },

            executeCommand: function (cmd) {

                TS.isString(cmd) && (cmd = this.getCommand(cmd));

                var me = this,
                    cmdCode = cmd.Code,
                    goOn = true,
                    handler,
                    fn,
                    context;

                if (!cmd) {
                    TS.Log.warn('executeCommand: cannot find command ' + cmdCode);
                    return;
                }

                if (cmd.InternalEnabled && !cmd.InternalEnabled())
                    return;

                if (TS.isFunction(cmd.beforeExecute)) {
                    goOn = cmd.beforeExecute();
                }

                if (goOn === false) {
                    TS.trace('Execution cancelled for command ' + cmdCode);
                    return;
                }

                handler = cmd.hasHandler() && TS.unwrap(cmd.handler);

                //try to find function on self and execute
                if (handler) {
                    context = cmd[TS.Constants.ownerProp] || me;
                    if (TS.isFunction(handler)) {
                        fn = handler;
                    } else {
                        fn = context[handler];
                    }
                    if (TS.isFunction(fn)) {
                        fn.apply(context, [cmd, true]);
                    } else {
                        TS.Notify.error('Cannot find handler ' + funcName + ' for command ' + cmdCode, 'Error');
                        return;
                    }
                } else {
                    me.performServerCommand(cmdCode, true);
                }
            },

            executeDefaultCommand: function () {
                var me = this,
                    recordCategory = me.CommandCategories['Record'],
                    firstDefaultCommand, command;
                $.each(recordCategory.Commands(), function (index, item) {
                    if (item.DefaultAction && TS.unwrap(item.DefaultAction) === true) {
                        if (item.InternalEnabled() && item.InternalVisible()) {
                            command = item;
                            return false;
                        }
                        firstDefaultCommand = firstDefaultCommand || item;
                    }
                });
                command = command || firstDefaultCommand;
                if (command)
                    return me.executeCommand(command);
            },

            /**
             * Performs a server-side command.
             * @param cmd {String|Object} Code of the command to be executed on server
             * @param [submitModel=true] Whether model data will be sent to the server.
             * @param [extraData=undefined] Additional information to be sent to server, as a JSON object. Server-side it's being passed to the specified command as a Dictionary<string, object>.
             * @param [callback=undefined] {Function} Function that will be called after response is received.
             * @param [ignoreResponse=false] {Boolean} When set to true, the response is being ignored. No data will be updated.
             * @param [blockUI=false] {Boolean} Set to true to block the UI during the command execution.
             * @returns [jqXHR]{@link http://api.jquery.com/jQuery.ajax/#jqXHR}
             *
             * @example
             * loadProject: function(code){
			 *   var me = this;
			 *
			 *   me.parent();
			 *
			 *   // call server-side command 'LoadProjectByCode' with additional parameters
			 *   me.performServerCommand({
			 *     cmd: 'LoadProjectByCode',
			 *     submitModel: false,
			 *     extraData: { projectCode: code}
			 *   })
			 * }
             */
            performServerCommand: function (cmd, submitModel, extraData, callback, ignoreResponse, blockUI) {
                var me = this,
                    data = {},
                    settings = {},
                    url;


                if (typeof cmd === 'object' && cmd !== null) {
                    settings = cmd;
                } else {
                    settings = {
                        cmd: cmd,
                        submitModel: submitModel,
                        extraData: extraData,
                        callback: callback,
                        ignoreResponse: ignoreResponse,
                        blockUI: blockUI
                    };
                }
                settings.queue = settings.queue !== false;

                //same command already executing
                if (me.executingCommandCode === settings.cmd)
                    return;

                TS.trace('Performing server command [' + settings.cmd + ']');
                data.cmd = settings.cmd;
                delete settings.cmd;
                settings.extraData && (data.extraData = JSON.stringify(ko.mapping.toJS(settings.extraData)));
                data.cmd && (me.executingCommandCode = data.cmd);
                url = me.getRootUrl() + 'PerformCommand/';
                return me.ajax(url, data, settings);
            },

            //endregion

            //region DomainProperties

            /**
             * Creates domain property.
             * @param name The name of the property.
             * @param config The configuration object containing property meta.
             */
            createProperty: function (name, config) {
                if (config && config.propertyType) {
                    config.Name = name;
                    config = TS.ObjectFactory.createObject(config.propertyType, this, config);
                    this[name] = config;
                    config.Name = name;
                    this.DomainProperties.push(config);
                }
            },

            /**
             * Creates domain properties.
             * @param config The configuration object containing properties meta.
             */
            createProperties: function (config) {
                $.each(config, this.createProperty.bind(this));
            },

            updateProperties: function (config) {
                var me = this;

                $.each(config, function (name, value) {
                    var property = me.getDomainProperty(name);
                    if (!property) {
                        me.createProperty(name, value);
                    } else {
                        property._setData && property._setData(value);
                    }
                });
            },

            /**
             * Retrieves a domain property by its name.
             * @param name Name of the property.
             * @returns {TS.viewModel.DomainProperty}
             */
            getDomainProperty: function (name) {
                var me = this,
                    ret = null;

                $.each(me.DomainProperties, function (idx, property) {
                    if (property.Name == name) {
                        ret = property;
                        return false;
                    }
                });

                return ret;
            },

            //endregion

            //region Subdomains

            createSubdomain: function (name, config) {
                var me = this,
                    domainType = config.__objecttype__ || 'TS.domain.Domain';
                var subdomainPath = name;
                me.subdomainPath && (subdomainPath = me.subdomainPath + '.' + subdomainPath);
                config.subdomainPath = subdomainPath;
                config.rootUrl = me.rootUrl;
                config.modelUID = me.modelUID;

                eval('domainType = ' + domainType);
                me[name] = new domainType(config);
            },

            createSubdomains: function (config) {
                var me = this,
                    domains = me.mapping.domains || [];
                $.each(domains, function (index, domainPropertyName) {
                    me.createSubdomain(domainPropertyName, config[domainPropertyName] || {});
                });
            },

            //endregion

            //region Bindings

            createBindings: function (config) {
                var me = this;
                try {
                    me.propertiesBinding = true;
                    $.each(config, function (source, destinations) {

                        function valueChanged(newValue) {
                            $.each(destinations, function (index, destination) {
                                ts.setPropertyValue(me, destination, newValue);
                            });
                        }

                        var binding = me.Bindings[source] = me.Bindings[source] || {},
                            accessor = binding.accessor = binding.accessor || me.watch(source, me, valueChanged);
                        valueChanged(accessor.value());
                    });
                }
                finally {
                    me.propertiesBinding = false;
                }
            },

            //endregion

            //region helpers

            _setWindowTitle: function () {
                window.document.title = ko.valueOf(this.Title) || '';
            },

            getRootUrl: function () {
                var me = this,
                    url = (TS.unwrap(me.rootUrl) || '') + '/';
                return url;
            },

            _showNotifications: function (notif, messages) {
                var me = this,
                    hasNotifications;

                // don't clear existing notifications if no new ones are being displayed
                hasNotifications = notif.informations || notif.errors || notif.validationerrors || notif.warnings;
                hasNotifications = !!hasNotifications;

                if (!hasNotifications) {
                    return;
                }

                TS.Notify.clear();

                if (TS.unwrap(me.showSuccessConfirmation) && notif.informations) {
                    TS.Notify.success(notif.informations);
                }

                me.showSuccessConfirmation = false;

                if (notif.errors) {
                    TS.Notify.error(notif.errors);
                }

                me.hideValidators();
                if (notif.validationerrors) {
                    TS.Notify.warning(notif.validationerrors);
                    if (messages) {
                        $.each(messages, function (idx, errInfo) {
                            if (errInfo.type === "validationerror") {
                                me.showControlValidation(errInfo.control, errInfo.text, true);
                            }
                        });
                    }
                }

                if (notif.warnings) {
                    TS.Notify.warning(notif.warnings);
                }
            },

            submit: function (callback) {
                var url = this.getRootUrl();
                url = url + 'Apply/';
                return this.ajax(url, {}, {callback: callback});
            },

            //endregion

            //region (un)bind

            _beforeBind: function () {
            },

            _afterBind: function () {
                var me = this;

                $.each(me.DomainProperties, function (idx, domainProp) {
                    domainProp._afterBind && domainProp._afterBind(me);
                });

                var notifications = TS.Util.getNotifications(me);
                me._showNotifications(notifications);
            },

            bind: function (rootNode) {
                console.time('bind');
                if (!this.boundNode && !this._isBinding) {
                    this._isBinding = true;
                    this._beforeBind();
                    ko.applyBindings(this, rootNode);
                    this.boundNode = rootNode;
                    this._isBinding = false;
                    this._afterBind();
                }
                console.timeEnd('bind');
            },

            unbind: function () {
                if (this.boundNode) {
                    ko.cleanNode(this.boundNode);
                    delete this.boundNode;
                }
            },

            //endregion

            //region ajax

            ajax: function (url, data, settings) {
                var me = this;

                if (settings.queue === true) {
                    if (me._isSubmitting) {
                        me._ajaxQueue = me._ajaxQueue || [];
                        me._ajaxQueue.push(arguments);
                        return;
                    }
                    me._isSubmitting = true;
                }

                function clearFlags(){
                    me.executingCommandCode = "";
                    me._isSubmitting = false;
                }

                function call(url, data, settings) {
                    data.modelUID = data.modelUID || ko.valueOf(me.modelUID);
                    !data.modelData && (settings.submitModel !== false) && (data.modelData = JSON.stringify(me._getData()));

                    TS.UI.Mask.show(settings.blockUI !== true);
                    return $.ajax(
                        $.extend({}, settings,
                            {
                                context: me,
                                type: settings.type || 'POST',
                                url: url,
                                data: JSON.stringify(data),
                                contentType: 'application/json; charset=utf-8',
                                dataType: "json",
                                finally: function () {
                                    clearFlags();
                                }
                            }))
                        .done(function () {
                            clearFlags();
                            if (settings.ignoreResponse !== true)
                                me.handleSuccess.apply(me, arguments);
                            if (settings.queue === true) {
                                if (me._ajaxQueue && me._ajaxQueue.length) {
                                    call.apply(me, me._ajaxQueue.splice(0, 1)[0]);
                                } else {
                                    TS.UI.Mask.hide();
                                }
                            } else {
                                TS.UI.Mask.hide();
                            }
                            settings.done && settings.done.apply(me, arguments);
                        })
                        .fail(function (jqXHR, textStatus) {
                            if (settings.queue === true && me._ajaxQueue && me._ajaxQueue.length) {
                                me._ajaxQueue.clear();
                            }
                            me.handleError.apply(me, arguments);
                            TS.UI.Mask.hide();
                            if (settings.fail) {
                                settings.fail.apply(me, arguments);
                            }
                        })
                        .always(function () {
                            settings.callback && settings.callback.apply(me, arguments);
                        });
                }

                call.apply(this, arguments);
            },

            handleSuccess: function (resp, textStatus, jqXHR) {
                var me = this;

                if (resp.success === false) {
                    notifications = TS.Util.getNotifications(resp);
                    me._showNotifications(notifications, resp.messages);
                } else {
                    if (resp.resultType == "Redirect") {
                        TS.UI.navigateTo(resp.data);
                        return;
                    }
                    if (resp.modelData) {
                        var targetModel = null;
                        if (resp.modelData.modelUID) {

                            var models = TS.UI.models,
                                currentModel = models.peek();
                            while (currentModel) {
                                if (currentModel && resp.modelData.modelUID === currentModel.modelUID) {
                                    targetModel = currentModel;
                                    break;
                                }
                                currentModel.close(true, false);
                                currentModel = models.peek();
                            }

                            /*$.each(TS.UI.models.stack, function (idx, item) {
                             if (item && resp.modelData.modelUID === TS.unwrap(item.modelUID)) {
                             targetModel = item;
                             return false;
                             }
                             });*/
                        }

                        if (targetModel == null)
                            TS.Log.warn('Cannot apply data for model ' + (resp.modelData ? resp.modelData.title : '') + ' - model does not exist ');
                        else {
                            targetModel._setData(resp.modelData);
                            var notifications = TS.Util.getNotifications(resp);
                            targetModel.showSuccessConfirmation = true;
                            targetModel._showNotifications(notifications, resp.messages);
                        }
                    }
                }
            },

            handleError: function (jqXHR, textStatus, errorThrown) {
                var errMsg;
                if (jqXHR.status == 500) {
                    try {
                        errMsg = JSON.parse(jqXHR.responseText);
                    } catch (ex) {
                        errMsg = 'Error processing server response. Error: ' + ex.message;
                    }
                    TS.Notify.error('Error: ' + errMsg, null, {
                        tapToDismiss: true
                    });
                }
            },

            //endregion

            //region (get)setData

            _getData: function () {
                var me = this,
                    domainProps = {},
                    result = ko.mapping.toJS(me);

                $.each(me.mapping.suppress, function (idx, prop) {
                    delete result[prop];
                });

                $.each(me.mapping.domains, function (idx, prop) {
                    result[prop] = me[prop]._getData();
                });

                $.each(me.DomainProperties, function (idx, domainProp) {
                    var data = domainProp._getData();
                    if (!TS.isEmpty(data)) {
                        data = $.extend(true, {}, data);
                        domainProps[domainProp.Name] = data;
                    }
                });
                if (!TS.isEmpty(domainProps)) {
                    result.DomainProperties = domainProps;
                }

                return result;
            },

            _setData: function (data) {
                var me = this;
                ko.mapping.fromJS(TS.makeDates(data), me);
                me.updateCommands(data.CommandCategories);
                me.updateProperties(data.DomainProperties);

                $.each(me.mapping.domains, function (idx, prop) {
                    if (me[prop]) {
                        if (data[prop]) {
                            data[prop].rootUrl = data.rootUrl;
                            data[prop].modelUID = data.modelUID;
                        }
                        data[prop] && me[prop]._setData(data[prop]);
                    } else {
                        me.createSubdomain(prop, data[prop] || {});
                    }
                });

                me._setWindowTitle();
            },

            //endregion

            //region Close command handler

            canClose: function () {
                return true;
            },

            closeCallback: function (resp, textStatus, jqXHR) {
                if (resp && resp.success === true) {
                    TS.UI.navigateTo(resp.data);
                }
                //else {
                //    TS.Notify.error("Error closing record");
                //}
            },

            close: function (triggerEvent, informServer, ignoreResponse) {
                var me = this,
                    isPopup = TS.unwrap(me.isPopup),
                    callback = $.noop;

                function popNraise() {
                    // cleanup the the stack
                    var currentModel = TS.UI.models.peek();
                    (currentModel.modelUID === me.modelUID) && TS.UI.models.pop();
                    if (triggerEvent !== false) {
                        me.trigger('close', {sender: me});
                    }
                }

                me.showSuccessConfirmation = false;

                if (triggerEvent !== false) {
                    var e = {sender: me};
                    me.trigger('closing', e);
                    if (e.ignoreResponse) {
                        ignoreResponse = !!e.ignoreResponse;
                    }
                }

                if (informServer) {
                    callback = function (resp, textStatus, jqXHR) {
                        var notifications = TS.Util.getNotifications(resp);
                        var success = !(notifications.validationerrors || notifications.errors);
                        if (success) {

                            //the model was not closed
                            if(resp.modelData && resp.modelData.modelUID === me.modelUID)
                                return;

                            popNraise();
                            //don't perform redirect for popups
                            if (!isPopup) {
                                me.closeCallback.apply(me, arguments);
                            }
                        }
                    };

                    me.performServerCommand({
                        cmd: 'Close',
                        submitModel: true,
                        callback: callback,
                        ignoreResponse: ignoreResponse
                    });
                } else {
                    popNraise();
                }
            },

            //endregion

            //region Validation
            showValidationError: function (errInfo) {
                this.showControlValidation(errInfo.control, errInfo.text);
            },

            showValidationMessageForPropertyPath: function (path, message) {
                var me = this;
                $.each(me.Validators, function (idx, item) {
                    if (path == item.propertyPath()) {
                        me.showControlValidation(item.control(), message);
                    }
                });
            },

            hideValidators: function () {
                var me = this;
                me.Validators && $.each(me.Validators, function (idx, item) {
                    me.showControlValidation(item.control());
                });
            },

            showControlValidation: function (control, text) {

                var validator = $("#body").kendoValidator().data("kendoValidator");

                if (!TS.isDefined(validator))
                    return;

                var INVALIDMSG = "k-invalid-msg",
                    INVALIDINPUT = "k-invalid",
                    NAME = "name",
                    input = $("#" + control),
                    that = validator,
                    template = that._errorTemplate,
                    className = "." + INVALIDMSG,
                    fieldName = (input.attr(NAME) || ""),
                    lbl = that._findMessageContainer(fieldName).add(input.next(className)).hide(),
                    messageText,
                    messageLabel,
                    valid;

                function decode(value) {
                    return value.replace(/&amp/g, '&amp;')
                        .replace(/&quot;/g, '"')
                        .replace(/&#39;/g, "'")
                        .replace(/&lt;/g, '<')
                        .replace(/&gt;/g, '>');
                }

                input.removeAttr("aria-invalid");

                if (text) {
                    messageText = text;
                    that._errors[fieldName] = messageText;
                    messageLabel = $(template({message: decode(messageText)}));

                    that._decorateMessageContainer(messageLabel, fieldName);

                    if (!lbl.replaceWith(messageLabel).length) {
                        messageLabel.insertAfter(input);
                    }
                    messageLabel.show();

                    input.attr("aria-invalid", true);
                }

                valid = text ? false : true;
                input.toggleClass(INVALIDINPUT, !valid);

                return valid;
            },

            //endregion

            /**
             * Watches an [observable]{@link http://knockoutjs.com/documentation/observables.html} and executes a callback
             * when the value changes.
             * Using this method has the benefit that subscriptions are automatically disposed when appropriate.
             * @param prop {Observable} The observable to be monitored.
             * @param func {Function} Function to be called when the value changes.
             * @param [context] {Object} Function will be called in this context
             * @param [before] {Boolean} When set to true, the callback function will be called before updating the observable value.
             * @returns {Function} Reference to the subscription function. You can hold this reference and terminate the subscription
             * at any time, by calling <code>.dispose()</code> on it.
             *
             * @example
             *
             * _hookProperties: function(){
			 *   var me = this;
			 *
			 *   me.parent();
			 *
			 *   me.watchProperty(me.Document.ProjectManagerId, function(newValue){
			 *     TS.log('ProjectManagerId changed to ' + newValue);
			 *   });
			 * }
             */
            watchProperty: function (prop, func, context, before) {
                var me = this,
                    s;

                if (!prop) {
                    TS.Log.warn('watchProperty: undefined property, cannot subscribe');
                    return;
                }

                if (prop && !prop.subscribe) {
                    TS.Log.warn('watchProperty: trying to subscribe to a non-observable property');
                    return;
                }

                s = prop.subscribe(func, context || me, before ? 'beforeChange' : null);
                me._subscriptions.push(s);
                return s;
            },

            _merge: function (cfg) {
                var me = this;

                if (cfg.Document) {
                    ko.mapping.fromJS(cfg.Document, {}, me.Document);
                    //the mapping plugin creates an empty '__ko_mapping__' property
                    // and later will ignore the data because this object is empty
                    delete me.Document.__ko_mapping__;
                }
                //$.extend(true, me.Document, cfg.Document);
            },
        });
})();